import { render, staticRenderFns } from "./UserFamilies.vue?vue&type=template&id=dc76bd9e&"
import script from "./UserFamilies.vue?vue&type=script&lang=js&"
export * from "./UserFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports